import type { DefaultTheme } from 'styled-components'
import styled from 'styled-components'
import get from 'lodash/get'

import type s4lColors from 'src/styles/colors/colors'
import type fontSizes from 'src/styles/typography/fontSizes'
import type fontFamilies from 'src/styles/typography/fonts'

import type DotNestedKeys from 'src/types/dotNested'

export interface TypographyProps {
  fontFamily?: DotNestedKeys<typeof fontFamilies>
  size?: DotNestedKeys<typeof fontSizes>
  color?: DotNestedKeys<typeof s4lColors>
  weight?: 400 | 500 | 600 | 700
}

type ThemedTypographyProps = TypographyProps & { theme: DefaultTheme }

export const fontMixin = ({ theme, fontFamily, size, color, weight }: ThemedTypographyProps) => `
  font-family:  ${
    fontFamily ? get(theme, `fonts.families.${fontFamily}`) : theme.fonts.families.primary
  };
  font-size: ${size ? get(theme, `fonts.sizes.${size}`) : theme.fonts.sizes.m};
  line-height: 130%;
  color: ${color ? get(theme, `colors.${color}`) : theme.colors.grey0};
  font-weight: ${weight !== undefined ? weight : 'normal'}; 
`

export const Paragraph = styled.p<TypographyProps>`
  ${props =>
    fontMixin({
      theme: props.theme,
      color: props.color || 'grey2',
      size: props.size || 'm',
      fontFamily: props.fontFamily || 'primary',
      weight: props.weight,
    })}
`

export const Heading = styled.h3<TypographyProps>`
  ${props =>
    fontMixin({
      theme: props.theme,
      color: props.color || 'grey2',
      size: props.size || 'm',
      fontFamily: props.fontFamily || 'primary',
      weight: props.weight || 700,
    })}
`
